import WidgetModule from "@eisinc/Overrides/Widgets/Common/PurchasedProducts";

export * from "@eisinc/Overrides/Widgets/Common/PurchasedProducts";

export default WidgetModule;
